// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createVendorPayoutAccount = (client) => ({
    /**
     * `POST /vendor/payout-account`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreatePayoutAccount
     * @source packages/modules/b2c-core/src/api/vendor/payout-account/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/payout-account", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/payout-account`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetPayoutAccount
     * @source packages/modules/b2c-core/src/api/vendor/payout-account/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/payout-account", { method: "GET", query, headers }),
    /**
     * `POST /vendor/payout-account/sync`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSyncPayoutAccount
     * @source packages/modules/b2c-core/src/api/vendor/payout-account/sync/route.ts
     */
    sync: (body, query, headers) => client.fetch("/vendor/payout-account/sync", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/payout-account/onboarding`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateOnboarding
     * @source packages/modules/b2c-core/src/api/vendor/payout-account/onboarding/route.ts
     */
    updateOnboarding: (body, query, headers) => client.fetch("/vendor/payout-account/onboarding", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=payout-account.js.map